import { jsx } from "react/jsx-runtime";
import { useRef } from "react";
import { DATA_HOOKS } from "../dataHooks.js";
import { classes } from "../FileUpload.st.css";
import File from "./File.js";
import FileUploadPopover from "./FileUploadPopover.js";
import { useFocusWhen } from "./use-focus-when.js";
import { usePrevious } from "./use-previous.js";
function FileList({
  fileInputRef,
  textBelowButtonRef,
  files,
  onDeleteClick,
  hasError,
  explanationText
}) {
  const indicateError = Boolean(files?.find((file) => file.state === "error")) && hasError;
  const isOneFile = files.length === 1;
  const singleFileDeleteButtonRef = useRef(null);
  const previousFileLength = usePrevious(files.length) ?? 0;
  useFocusWhen(() => {
    return files.length === 1 && previousFileLength > 1;
  }, singleFileDeleteButtonRef);
  const handleDeleteClick = (i) => {
    const fileToDelete = files?.[i].file;
    if (fileToDelete && fileInputRef.current && `${fileInputRef.current.value}`.includes(fileToDelete.name)) {
      fileInputRef.current.value = "";
    }
    onDeleteClick?.(i);
  };
  if (isOneFile) {
    return /* @__PURE__ */ jsx("div", { className: classes.oneFile, ref: textBelowButtonRef, children: /* @__PURE__ */ jsx(
      File,
      {
        file: files[0],
        onDeleteClick: () => handleDeleteClick(0),
        dataHook: DATA_HOOKS.singleFile,
        deleteButtonRef: singleFileDeleteButtonRef
      }
    ) });
  }
  return /* @__PURE__ */ jsx(
    FileUploadPopover,
    {
      files,
      onDeleteClick: handleDeleteClick,
      explanationText,
      hasError: indicateError,
      setTextBelowButtonRef: (element) => textBelowButtonRef.current = element
    }
  );
}
export {
  FileList
};
//# sourceMappingURL=FileList.js.map
